import ShimmerTopCategories from "components/shimmer/ShimmerTopCategories";
import useTopCatalogueData from "hook/useTopCatalogueData";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
const TopCategories = () => {
  const { topCatalogues, loadingTopCatalogue } = useTopCatalogueData();
  if (loadingTopCatalogue) return <ShimmerTopCategories />;

  return (
    <section className="mt-10 px-4 sm:px-6">
      {topCatalogues.length > 0 ? (
        <div className="mb-4 flex items-end justify-between">
          <div>
            <h3 className="text-xl font-bold text-slate-900 sm:text-2xl">
              Top Categories
            </h3>
            <p className="text-sm text-slate-600 sm:text-base">
              Most visited categories this week.
            </p>
          </div>
        </div>
      ) : null}

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {topCatalogues.map((category) => (
          <Link
            key={category.id}
            to={`/category/${category.catalogue_id}`}
            className="group overflow-hidden rounded-2xl bg-white text-left shadow-sm ring-1 ring-slate-100 transition duration-200 hover:-translate-y-0.5 hover:shadow-md"
          >
            <div className="relative h-36 w-full">
              <img
                src={`https://backend.nuhababy.com/${category.image_path}`}
                alt={category.title}
                className="h-full w-full object-cover transition duration-300 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/20 to-transparent" />
            </div>
            <div className="p-4">
              <h4 className="text-base font-bold text-slate-900 sm:text-lg">
                {category.title}
              </h4>
              {/* <p className="mt-1 text-sm text-slate-600">{category.title}</p> */}
              <span className="mt-1 inline-flex items-center gap-2 text-xs font-semibold text-blue-600 sm:text-sm">
                Shop Category
                <FaArrowRight />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default TopCategories;
